import { PO_STATUS_LABEL, PO_STATUS_TONE } from "@/lib/constants";
import { StatusBadge } from "./StatusBadge";

export function POStatusBadge({ status, ...props }) {
  return (
    <StatusBadge tone={PO_STATUS_TONE[status] || "muted"} {...props}>
      {PO_STATUS_LABEL[status] || status}
    </StatusBadge>
  );
}
